import { TicketWizard, Ticket, TicketOverview } from 'projects/flow-gui-access/views/ticket'

module.exports = [
  {
    path: '/ticket/wizard',
    exact: true,
    component: TicketWizard
  }, {
    path: '/ticket/wizard/:accessId',
    exact: true,
    component: TicketWizard
  }, {
    path: '/ticket/wizard/:accessId/:service',
    exact: true,
    component: TicketWizard
  }, {
    path: '/ticket',
    exact: true,
    component: TicketOverview
  }, {
    path: '/ticket/:ticketId',
    exact: true,
    component: Ticket
  }
]



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/routes/ticket.js